import { Checkbox, FormControlLabel } from '@mui/material';
import React, { FC } from 'react';
import {
    CheckboxBlankIcon,
    CheckboxCheckedIcon,
    CheckboxDisableIcon,
    CheckboxIndeterminateIcon,
} from 'assets/icons';

interface AppCheckboxProps {
    label?: string;
    checked?: boolean;
    disabled?: boolean;
    defaultChecked?: boolean;
    indeterminate?: boolean;
    name?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

const AppCheckbox: FC<AppCheckboxProps> = (props) => {
    const { checked, disabled, indeterminate, onChange, label, name } = props;

    return (
        <FormControlLabel
            control={
                <Checkbox
                    name={name}
                    icon={disabled ? <CheckboxDisableIcon /> : <CheckboxBlankIcon />}
                    checkedIcon={disabled ? <CheckboxDisableIcon /> : <CheckboxCheckedIcon />}
                    indeterminateIcon={<CheckboxIndeterminateIcon />}
                    checked={checked}
                    indeterminate={indeterminate}
                    onChange={disabled ? undefined : onChange}
                    disableRipple={disabled}
                />
            }
            label={label}
            sx={{
                '& .MuiFormControlLabel-label': {
                    fontFamily: 'Meiryo',
                    fontWeight: 400,
                    fontSize: '16px',
                },
            }}
        />
    );
};

export default AppCheckbox;
